import convertTo12HourFormatObject from './convertTo12HourFormatObject';
import convertTo24HourFormatObject from './convertTo24HourFormatObject';
import detectTimeFormat from './detectTimeFormat';

export const formatTimeForDisplay = (time: string): string => {
  const timeFormat = detectTimeFormat();
  if (timeFormat === '12-hour') {
    const convertedTime = convertTo12HourFormatObject(time);
    return `${convertedTime.hour}:${convertedTime.minute} ${convertedTime.period}`;
  }
  const convertedTime = convertTo24HourFormatObject(time);
  return `${convertedTime.hour}:${convertedTime.minute}`;
};
